export { default } from "./TermsAgreementForm";
export type { TermsAgreementFormProps } from "./TermsAgreementForm";
